import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { API_ROUTES } from "@/utils/API";
import axios from "@/plugins/http";
import {
  API_TTeammates,
  convertTeammatesForTable,
  TTeammates_Select,
  TTeammates_Table,
  convertTeammatesForSelect,
  TTeammates_Status_Case,
  TTeammates_Status,
  convertTeammatesCases,
  TTeammates_Case_Table,
  TTeammate_Delete_Params,
} from "@/models/company_teammates";

@Module({ name: "MTeammates", namespaced: true })
export default class MTeammates extends VuexModule {
  loading = false;

  teammates: TTeammates_Table[] = [];

  teammatesAdminOptions: TTeammates_Select[] = [];

  teammatesOptions: TTeammates_Select[] = [];

  @Mutation
  setLoading(payload: boolean) {
    this.loading = payload;
  }

  @Mutation
  setTeammates(data: API_TTeammates[]) {
    this.teammates = data.map((a: API_TTeammates) => convertTeammatesForTable(a));
  }

  @Mutation
  setTeammatesAdminOptions(data: API_TTeammates[]) {
    this.teammatesAdminOptions = data.map((a: API_TTeammates) => convertTeammatesForSelect(a));
  }

  @Mutation
  setTeammatesOptions(data: API_TTeammates[]) {
    this.teammatesOptions = data.map((a: API_TTeammates) => convertTeammatesForSelect(a));
  }

  @Action
  async getTeammates(isAdmin = false) {
    try {
      this.setLoading(true);

      const { data } = await axios.get(API_ROUTES.COMPANY_TEAMMATES(isAdmin));

      if (!data) return;

      this.setTeammates(data);

      isAdmin ? this.setTeammatesAdminOptions(data) : this.setTeammatesOptions(data);
    } finally {
      // this.setLoading(false);
    }
  }

  cases: TTeammates_Case_Table[] = [];

  @Mutation
  setCases(data: TTeammates_Status_Case[]) {
    this.cases = data.map((a: TTeammates_Status_Case) => convertTeammatesCases(a));
  }

  status: TTeammates_Status = {
    cases: [],
    is_compliance_admin: false,
    is_has_cases: false,
    teammate_name: "",
    email: "",
  };

  @Mutation
  setStatus(data: TTeammates_Status) {
    this.status = data;
  }

  @Action
  async getTeammatesDeleteStatus(userId: number) {
    if (!userId) return;

    this.setLoading(true);

    try {
      const { data } = await axios.get<TTeammates_Status>(
        API_ROUTES.COMPANY_TEAMMATES_DELETE_STATUS(userId)
      );

      if (!data) return;

      this.setStatus(data);

      if (data.is_has_cases) this.setCases(data.cases);
    } finally {
      // this.setLoading(false);
    }
  }

  deleteLoading = false;

  @Mutation
  setDeleteLoading(payload: boolean) {
    this.deleteLoading = payload;
  }

  @Action
  async deleteTeammate({ userId, params }: { userId: number; params: TTeammate_Delete_Params }) {
    this.setDeleteLoading(true);

    try {
      await axios.delete(API_ROUTES.COMPANY_TEAMMATES_DELETE(userId), {
        data: params,
      });
    } finally {
      this.setDeleteLoading(false);
    }
  }
}
